import React from 'react'
import { Box, Heading, VStack } from '@chakra-ui/react'
import { Droppable, Draggable, DroppableProvided, DraggableProvided } from '@hello-pangea/dnd'
import { Task } from './types'
import TaskCard from './TaskCard'

interface TaskColumnProps {
  cardBg: string
  cardBorder: string
  column: {
    id: string
    taskIds: string[]
    title: string
  }
  columnBgColor: string
  onDelete: (taskId: string) => void
  onEdit: (task: Task) => void
  tasks: Task[]
}

const TaskColumn: React.FC<TaskColumnProps> = ({
  cardBg,
  cardBorder,
  column,
  columnBgColor,
  onDelete,
  onEdit,
  tasks
}) => (
  <Box
    width={{ base: '100%', md: '32%' }}
    bg={columnBgColor}
    p={4}
    borderRadius="md"
    boxShadow="md"
    height="fit-content"
    minH="300px"
  >
    <Heading size="md" mb={4} textAlign="center">
      {column.title} ({tasks.length})
    </Heading>
    <Droppable droppableId={column.id}>
      {(provided: DroppableProvided) => (
        <VStack
          ref={provided.innerRef}
          {...provided.droppableProps}
          spacing={2}
          alignItems="stretch"
          minH="200px"
          bg="transparent"
        >
          {tasks.map((task, index) => (
            <Draggable key={task.id} draggableId={task.id} index={index}>
              {(provided: DraggableProvided) => (
                <Box
                  ref={provided.innerRef}
                  {...provided.draggableProps}
                  {...provided.dragHandleProps}
                >
                  <TaskCard
                    task={task}
                    onEdit={onEdit}
                    onDelete={onDelete}
                    cardBg={cardBg}
                    cardBorder={cardBorder}
                  />
                </Box>
              )}
            </Draggable>
          ))}
          {provided.placeholder}
        </VStack>
      )}
    </Droppable>
  </Box>
)

export default TaskColumn
